import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/Logo.svg'
import _imports_1 from '@/assets/images/header-svg/consultar.svg'
import _imports_2 from '@/assets/images/header-svg/computer.svg'
import _imports_3 from '@/assets/images/header-svg/icons-certificate.svg'
import _imports_4 from '@/assets/images/header-svg/alterar.svg'
import _imports_5 from '@/assets/images/header-svg/videoconferencia.svg'
import _imports_6 from '@/assets/images/header-svg/agendar.svg'
import _imports_7 from '@/assets/images/header-svg/documentos-pendentes.svg'
import _imports_8 from '@/assets/images/header-svg/solicitar.svg'


const _hoisted_1 = { class: "header-component" }
const _hoisted_2 = { class: "navbar navbar--ilios navbar-expand-md d-flex flex-row justify-content-end" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  class: "navbar-toggler d-flex",
  type: "button",
  "data-ilios-navbar-slide-target": "#menuMobile",
  "data-ilios-toggle": "navbar-slide",
  "aria-controls": "menuMobile",
  "arial-label": "Abrir Menu"
}
const _hoisted_5 = { class: "logo-mobile" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "mx-3",
  src: _imports_0,
  alt: "logo ar"
}
const _hoisted_8 = {
  class: "navbar-slide",
  id: "menuMobile"
}
const _hoisted_9 = {
  class: "navbar-toggler",
  id: "btnClose",
  type: "button",
  "data-ilios-navbar-slide-target": "#menuMobile",
  "data-ilios-toggle": "navbar-slide",
  "aria-controls": "menuMobile",
  "aria-label": "Fechar Menu"
}
const _hoisted_10 = { class: "navbar--body" }
const _hoisted_11 = { class: "nav-item item-list" }
const _hoisted_12 = { class: "nav-item item-list item-icon" }
const _hoisted_13 = { class: "nav-item item-list item-icon" }
const _hoisted_14 = { class: "item-list item-icon" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "navbar--informations d-flex flex-column" }
const _hoisted_17 = { class: "d-flex flex-row justify-content-start p-3" }
const _hoisted_18 = { class: "mx-2" }
const _hoisted_19 = { class: "d-flex flex-row justify-content-start p-3" }
const _hoisted_20 = { class: "mx-2" }
const _hoisted_21 = { class: "d-flex flex-column" }
const _hoisted_22 = { class: "d-flex flex-row justify-content-start p-3" }
const _hoisted_23 = {
  class: "w-100 d-flex flex-row justify-content-between",
  "data-bs-toggle": "collapse",
  href: "#collapseFaqItems",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}
const _hoisted_24 = {
  class: "p-3",
  id: "collapseFaqItems"
}
const _hoisted_25 = { class: "list-unstyled" }
const _hoisted_26 = { class: "d-flex flex-row justify-content-start p-3" }
const _hoisted_27 = {
  key: 0,
  href: "https://www.soluti.com.br/fale-conosco",
  target: "_blank"
}
const _hoisted_28 = { class: "item-icon" }
const _hoisted_29 = { class: "item-icon" }
const _hoisted_30 = { class: "item-icon" }
const _hoisted_31 = { class: "item-icon" }
const _hoisted_32 = { class: "item-icon" }
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 0,
  class: "item-icon"
}
const _hoisted_35 = {
  key: 1,
  class: "item-icon"
}
const _hoisted_36 = { class: "item-icon" }
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "item-icon" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { id: "menuDesktop" }
const _hoisted_41 = { class: "navbar-nav me-auto d-flex flex-row justify-content-end" }
const _hoisted_42 = { class: "phone-info mx-2 d-flex flex-row align-items-center gap-1" }
const _hoisted_43 = { class: "mx-1" }
const _hoisted_44 = { class: "site-info mx-2 d-flex" }
const _hoisted_45 = { class: "mx-1 color--secondary-900" }
const _hoisted_46 = ["href"]
const _hoisted_47 = {
  key: 0,
  class: "mx-2",
  href: "https://www.soluti.com.br/fale-conosco",
  target: "_blank"
}
const _hoisted_48 = { class: "navbar navbar-content-bottom navbar-expand-md" }
const _hoisted_49 = { class: "container-fluid" }
const _hoisted_50 = { class: "navbar-nav" }
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 1,
  class: "mx-3",
  src: _imports_0,
  alt: "logo ar"
}
const _hoisted_53 = { class: "nav-item item-list dropdown ms-3 d-flex flex-column justify-content-center" }
const _hoisted_54 = {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_55 = { class: "dropdown-menu p-3" }
const _hoisted_56 = { class: "dropdown-item px-0" }
const _hoisted_57 = ["href"]
const _hoisted_58 = {
  key: 0,
  class: "dropdown-item px-0"
}
const _hoisted_59 = {
  key: 1,
  class: "dropdown-item px-0 border-0"
}
const _hoisted_60 = { class: "nav-item item-list dropdown ms-3 d-flex flex-column justify-content-center" }
const _hoisted_61 = { class: "nav-item item-list dropdown d-flex flex-column justify-content-center" }
const _hoisted_62 = {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  target: "_blank"
}
const _hoisted_63 = { class: "dropdown-menu p-3" }
const _hoisted_64 = { class: "dropdown-item px-0" }
const _hoisted_65 = ["href"]
const _hoisted_66 = { class: "dropdown-item px-0 border-0" }
const _hoisted_67 = ["href"]
const _hoisted_68 = { class: "item-list d-flex flex-column justify-content-center" }
const _hoisted_69 = ["href"]
const _hoisted_70 = { class: "item-list d-flex flex-column justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_FAQSidebarBody = _resolveComponent("FAQSidebarBody")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.arData.logo !== "")
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "mx-3",
                    src: _ctx.arData.logo,
                    alt: "logo ar"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("span", null, [
                _createVNode(_component_Icon, {
                  class: "close-icon",
                  name: "xmark"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("ul", {
                class: _normalizeClass(["navbar-nav", _ctx.menuShow.firstMenu ? "" : "d-none"])
              }, [
                _createElementVNode("li", _hoisted_11, [
                  _createElementVNode("a", {
                    class: "nav-link active item-icon",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCertificadeMenu && _ctx.openCertificadeMenu(...args)))
                  }, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "Emitir Certificado", -1)),
                    _createVNode(_component_Icon, { name: "chevron-right" })
                  ])
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    target: "_self",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo("/guia-de-instalacao-de-certificado-digital")))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "Instalar Certificado", -1)),
                    _createVNode(_component_Icon, { name: "chevron-right" })
                  ])
                ]),
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openRevokeMenu && _ctx.openRevokeMenu(...args)))
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "Revogar Certificado", -1)),
                    _createVNode(_component_Icon, { name: "chevron-right" })
                  ])
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/verificar-situacao-de-emissao`
                  }, _cache[15] || (_cache[15] = [
                    _createElementVNode("span", null, "Consultar situação de Certificado", -1)
                  ]), 8, _hoisted_15)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Icon, { name: "user" }),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.arData.foneAR || '(19) 98118-0008'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Icon, { name: "globe" }),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getSiteArFormatted), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("a", _hoisted_23, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Ajuda", -1)),
                        _createVNode(_component_Icon, { name: "chevron-right" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("ul", _hoisted_25, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_FAQSidebarBody)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (_ctx.isPartner)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_27, "Fale conosco"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2),
              _createElementVNode("ul", {
                class: _normalizeClass(["navbar-nav", _ctx.menuShow.installMenu ? "" : "d-none"])
              }, [
                _createElementVNode("h2", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    class: "me-2",
                    name: "chevron-left"
                  }),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "h-x-small fw-semi-bold" }, "Instalar Certificado", -1))
                ]),
                _createElementVNode("li", _hoisted_28, [
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo("/installation-guide-birdid")))
                  }, _cache[18] || (_cache[18] = [
                    _createElementVNode("img", {
                      class: "me-2",
                      style: {"width":"40px"},
                      src: _imports_1
                    }, null, -1),
                    _createElementVNode("span", null, "Bird ID", -1)
                  ]))
                ]),
                _createElementVNode("li", _hoisted_29, [
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo("/issue/plugin")))
                  }, _cache[19] || (_cache[19] = [
                    _createElementVNode("img", {
                      class: "me-2",
                      style: {"width":"40px"},
                      src: _imports_2
                    }, null, -1),
                    _createElementVNode("span", null, "Computador", -1)
                  ]))
                ]),
                _createElementVNode("li", _hoisted_30, [
                  _createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo("/installation-guide-token")))
                  }, _cache[20] || (_cache[20] = [
                    _createElementVNode("img", {
                      class: "me-2",
                      style: {"width":"40px"},
                      src: _imports_3
                    }, null, -1),
                    _createElementVNode("span", null, "Token e Smartcard", -1)
                  ]))
                ]),
                _createElementVNode("li", _hoisted_31, [
                  _createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigateTo("/ssl-certificate/installation-guide-ssl")))
                  }, _cache[21] || (_cache[21] = [
                    _createElementVNode("img", {
                      class: "me-2",
                      style: {"width":"40px"},
                      src: _imports_4
                    }, null, -1),
                    _createElementVNode("span", null, "SSL", -1)
                  ]))
                ])
              ], 2),
              _createElementVNode("ul", {
                class: _normalizeClass(["navbar-nav", _ctx.menuShow.certificadeMenu ? "" : "d-none"])
              }, [
                _createElementVNode("h2", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    class: "me-2",
                    name: "chevron-left"
                  }),
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "h-x-small fw-semi-bold" }, "Emitir Certificado", -1))
                ]),
                _createElementVNode("li", _hoisted_32, [
                  _cache[23] || (_cache[23] = _createElementVNode("img", { src: _imports_5 }, null, -1)),
                  _createElementVNode("a", {
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/emissao-online`
                  }, "Por videoconferência", 8, _hoisted_33)
                ]),
                (_ctx.isPartner)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_34, _cache[24] || (_cache[24] = [
                      _createElementVNode("img", { src: _imports_6 }, null, -1),
                      _createElementVNode("a", {
                        href: "https://idtech.soluti.com.br/lojas",
                        target: "_blank"
                      }, "Agendar visita presencial", -1)
                    ])))
                  : _createCommentVNode("", true),
                (_ctx.isPartner)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                      _cache[26] || (_cache[26] = _createElementVNode("img", { src: _imports_7 }, null, -1)),
                      _createVNode(_component_router_link, {
                        class: "dropdown-item",
                        to: "/login-documents"
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode("Enviar documentos pendentes")
                        ])),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("ul", {
                class: _normalizeClass(["navbar-nav", _ctx.menuShow.revokeMenu ? "" : "d-none"])
              }, [
                _createElementVNode("h2", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    class: "me-2",
                    name: "chevron-left"
                  }),
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "h-x-small fw-semi-bold" }, "Revogar Certificado", -1))
                ]),
                _createElementVNode("li", _hoisted_36, [
                  _cache[28] || (_cache[28] = _createElementVNode("img", { src: _imports_8 }, null, -1)),
                  _createElementVNode("a", {
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/revogar`
                  }, "Solicitar revogação", 8, _hoisted_37)
                ]),
                _createElementVNode("li", _hoisted_38, [
                  _cache[29] || (_cache[29] = _createElementVNode("img", { src: _imports_4 }, null, -1)),
                  _createElementVNode("a", {
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/senharevogacao`
                  }, "Alterar senha de revogação", 8, _hoisted_39)
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("ul", _hoisted_41, [
              _createElementVNode("li", _hoisted_42, [
                _createVNode(_component_Icon, {
                  class: "mx-1 icon",
                  name: "phone"
                }),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.arData.foneAR), 1)
              ]),
              _createElementVNode("li", _hoisted_44, [
                _createVNode(_component_Icon, {
                  class: "mx-1 icon",
                  name: "globe"
                }),
                _createElementVNode("a", _hoisted_45, [
                  _createElementVNode("span", {
                    target: "_blank",
                    href: _ctx.arData.siteAR
                  }, _toDisplayString(_ctx.getSiteArFormatted), 9, _hoisted_46)
                ])
              ]),
              _createElementVNode("li", null, [
                (_ctx.isPartner)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_47, "Fale conosco"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("nav", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("ul", _hoisted_50, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.navigateToHome && _ctx.navigateToHome(...args))),
                type: "button"
              }, [
                (_ctx.arData.logo !== "")
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "mx-3",
                      src: _ctx.arData.logo,
                      alt: "logo ar"
                    }, null, 8, _hoisted_51))
                  : (_openBlock(), _createElementBlock("img", _hoisted_52))
              ])
            ]),
            _createElementVNode("li", _hoisted_53, [
              _createElementVNode("a", _hoisted_54, [
                _cache[30] || (_cache[30] = _createElementVNode("span", null, "Emitir Certificado", -1)),
                _createVNode(_component_Icon, {
                  class: "ms-2",
                  name: "chevron-down"
                })
              ]),
              _createElementVNode("ul", _hoisted_55, [
                _createElementVNode("li", _hoisted_56, [
                  _createElementVNode("a", {
                    class: "d-flex align-items-center content-container py-2 px-3",
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/emissao-online`,
                    target: "_blank"
                  }, _cache[31] || (_cache[31] = [
                    _createElementVNode("img", {
                      class: "me-3",
                      src: _imports_5
                    }, null, -1),
                    _createElementVNode("span", null, "Por videoconferência", -1)
                  ]), 8, _hoisted_57)
                ]),
                (_ctx.isPartner)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_58, _cache[32] || (_cache[32] = [
                      _createElementVNode("a", {
                        class: "d-flex align-items-center content-container py-2 px-3",
                        href: "https://idtech.soluti.com.br/lojas",
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          class: "me-3",
                          src: _imports_6
                        }),
                        _createElementVNode("span", null, "Agendar visita presencial")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (_ctx.isPartner)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                      _createVNode(_component_router_link, {
                        class: "d-flex align-items-center content-container py-2 px-3",
                        to: "/login-documents"
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createElementVNode("img", {
                            class: "me-3",
                            src: _imports_7
                          }, null, -1),
                          _createElementVNode("span", null, "Enviar documentos pendentes", -1)
                        ])),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("li", _hoisted_60, [
              _createVNode(_component_router_link, {
                class: "me-3",
                to: "/guia-de-instalacao-de-certificado-digital",
                role: "button",
                target: "_self"
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createElementVNode("span", null, "Instalar Certificado", -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_61, [
              _createElementVNode("a", _hoisted_62, [
                _cache[35] || (_cache[35] = _createElementVNode("span", null, "Revogar Certificado", -1)),
                _createVNode(_component_Icon, {
                  class: "ms-2",
                  name: "chevron-down"
                })
              ]),
              _createElementVNode("ul", _hoisted_63, [
                _createElementVNode("li", _hoisted_64, [
                  _createElementVNode("a", {
                    class: "d-flex align-items-center content-container py-2 px-3",
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/revogar`,
                    target: "_blank"
                  }, _cache[36] || (_cache[36] = [
                    _createElementVNode("img", {
                      class: "me-3",
                      style: {"width":"33px"},
                      src: _imports_8
                    }, null, -1),
                    _createElementVNode("span", null, "Solicitar revogação", -1)
                  ]), 8, _hoisted_65)
                ]),
                _createElementVNode("li", _hoisted_66, [
                  _createElementVNode("a", {
                    class: "d-flex align-items-center content-container py-2 px-3",
                    href: `https://${_ctx.subdomain}.acsoluti.com.br/site/senharevogacao`,
                    target: "_blank"
                  }, _cache[37] || (_cache[37] = [
                    _createElementVNode("img", {
                      class: "me-3",
                      style: {"width":"33px"},
                      src: _imports_4
                    }, null, -1),
                    _createElementVNode("span", null, "Alterar senha de revogação", -1)
                  ]), 8, _hoisted_67)
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_68, [
              _createElementVNode("a", {
                class: "nav-link",
                href: `https://${_ctx.subdomain}.acsoluti.com.br/site/verificar-situacao-de-emissao`,
                role: "button",
                target: "_blank"
              }, _cache[38] || (_cache[38] = [
                _createElementVNode("span", null, "Consultar situação de Certificado", -1)
              ]), 8, _hoisted_69)
            ]),
            _createElementVNode("li", _hoisted_70, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/faq"
              }, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createElementVNode("span", null, "Ajuda", -1)
                ])),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}